/**
 * Customer Store - Internal
 *
 * Uses createPersistedStore from module-core for automatic SSR handling
 * @see mobile: module-customer/src/stores/customer-profile.store.ts
 */

import { type Observable } from '@legendapp/state';
import { createPersistedStore } from '@kidslabs/module-core';
import type { CustomerAddress, Customer, Maybe } from '../types/front.graphql';

interface CustomerStoreState {
    /** Current customer profile - matches mobile's customerProfile$.currentCustomer */
    currentCustomer?: Customer;
    addresses: CustomerAddress[];
    /** Address ID type matches GraphQL CustomerAddress.id (Maybe<number>) */
    defaultShippingAddressId?: Maybe<number>;
    defaultBillingAddressId?: Maybe<number>;
    selectedAddressId?: Maybe<number>;
    /** Default or first address - matches mobile's customerProfile$.defaultOrFirstAddress */
    defaultOrFirstAddress?: CustomerAddress;
    isLoading: boolean;
    error?: string;
}

const initialState: CustomerStoreState = {
    currentCustomer: undefined,
    addresses: [],
    defaultShippingAddressId: undefined,
    defaultBillingAddressId: undefined,
    selectedAddressId: undefined,
    defaultOrFirstAddress: undefined,
    isLoading: false,
    error: undefined,
};

/**
 * Customer observable store with automatic IndexedDB persistence
 *
 * ✅ No manual SSR checks needed
 * ✅ Automatic persistence on client-side
 * ✅ Works as regular observable on server-side
 */
export const customerStore$: Observable<CustomerStoreState> = createPersistedStore('customer', initialState);
